import { FC } from 'react';
import { ProDatePicker } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { DatePickerProps } from 'antd/lib/date-picker';
import { DEFAULT_DATA_FORMAT } from '../constants/constant';

export interface SearchFormDatePickerProps extends BaseSearchFormItemProps {
  /** datePicker Props */
  datePickerProps?: DatePickerProps;
}
/** 日期时间表单 */
export const SearchFormDatePicker: FC<SearchFormDatePickerProps> = props => {
  const {
    datePickerProps,
    render,
    disabledRender,
    isDetail,
    form,
    isTable,
    name,
    testId,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      name={name}
      test-id={`${testId}-${name}`}
      label={label}
      rules={rules}
    >
      {isDetail || (datePickerProps && datePickerProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          isMoment
          render={render || disabledRender}
          format={(datePickerProps?.format as string) || DEFAULT_DATA_FORMAT}
          isTable={isTable}
        />
      ) : (
        <ProDatePicker
          style={{ width: '100%' }}
          format={DEFAULT_DATA_FORMAT}
          {...datePickerProps}
          placeholder={getSelectPlaceholder(label, datePickerProps, rules)}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormDatePicker.displayName = SearchFormItemEnum.SearchFormDatePicker;

export default SearchFormDatePicker;
